
<div class="card">
    <div class="card-header card-header-squirrel">
        <h4>Squirrel Umgebung löschen</h4>
    </div>
    <div class="card-body">
        <form [formGroup]="squirrelEnvironmentForm" novalidate>

            <mat-form-field style="width: 0; height: 0;">
                <input matInput hidden formControlName="id" readonly>
            </mat-form-field>
    
            <div class="row">
                <div class="col-md-12">
                    <mat-form-field class="example-full-width">
                        <input matInput placeholder="Environment Name" disabled="disabled" formControlName="name" readonly>
                        <!-- <button  mat-button matSuffix mat-icon-button (click)="delete(data.id)" color="primary">
                            <mat-icon>delete</mat-icon>
                        </button> -->
                    </mat-form-field>
                </div>
            </div>   
        </form>
        <div class="row">
            <a>
            <button mat-raised-button class="btn btn-squirrel" style="margin-top: 6px;margin-left: 0px" matTooltip="Dialog schließen"
                            (click)="cancel()" >Abbruch</button>
            </a>                                                
            <span style="flex: 1 1 auto"></span>
            <a>
                    <button mat-raised-button class="btn btn-squirrel" style="margin-top: 6px;" matTooltip="Umgebung löschen"
                                    (click)="delete(data.id)" >Löschen</button>
            </a>                   
        </div>
    </div>
</div>